//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, } from 'react';
import { useSelector } from 'react-redux';

// === STYLE / MATERIAL UI ===
import {
  Box,
} from '@mui/material';

// === COMPONENTS ===
import { TaskMonitor      } from '../TaskMonitor/TaskMonitor'           ;
import { CorrectionMode   } from '../CorrectionMode/CorrectionMode'     ;
import { SubmitTaskButton } from '../SubmitTaskButton/SubmitTaskButton' ;
import { InfoChips        } from '../InfoChips/InfoChips'               ;
import { CancelTaskButton } from '../CancelTaskButton/CancelTaskButton' ;
import { ModeSelect       } from '../ModeSelect/ModeSelect'             ;  
import { GoToPage         } from 'pages/TaskVerification/components/TaskPanel/components/GoToPage/GoToPage';

//#endregion

//-----------------------------------------------------------------
export function TaskVerifyBar() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const page = useSelector((state) => state.display.page);
  const is_verify = page === 'verify';
  
  const _styles = {
    container: {
      display: is_verify ? 'flex' : 'none',
      padding : '0.5rem' ,
      width   : '100%' ,
    }
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box sx={_styles.container}>
        <TaskMonitor      />
        <CancelTaskButton />
        <SubmitTaskButton />
        <ModeSelect       />
        <GoToPage         />
        <InfoChips        />
      </Box>
    )
  }

  //#endregion

  return display();
}